import React from 'react';
import { motion } from 'framer-motion';
import {
  Server,
  Code,
  Settings,
  Briefcase,
  Cloud,
  Wrench
} from 'lucide-react';

const paragraphLines = [
  "With over 8 years of experience across fleet, fuel, and marine management solutions, I’ve led everything from field engineering to cloud-focused solution architecture.",
  "I’ve built, deployed, and optimized critical infrastructure for businesses that rely on performance and precision.",
  "As a co-founder at Roie Technologies, I’ve architected B2C GPS platforms from the ground up.",
  "My journey has spanned DevOps, infrastructure engineering, software architecture, stakeholder engagement, and project management—each role reinforcing my problem-solving edge.",
  "Whether it’s scaling a cloud system, building internal tools, or stepping into fire-fighting mode—I’m your go-to.",
  "Welcome to my site. Scroll down to see the story I’ve squeezed into this one-pager."
];

const textVariant = {
  hidden: { opacity: 0, y: 10 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.3
    }
  })
};

const roleBadges = [
  { icon: <Wrench className="w-6 h-6" />, label: "Field Engineer" },
  { icon: <Code className="w-6 h-6" />, label: "Software Architect" },
  { icon: <Server className="w-6 h-6" />, label: "Infra & DevOps" },
  { icon: <Cloud className="w-6 h-6" />, label: "Cloud Strategist" },
  { icon: <Briefcase className="w-6 h-6" />, label: "Project Manager" },
  { icon: <Settings className="w-6 h-6" />, label: "Business Optimizer" }
];

const About = () => {
  return (
    <section
      id="about"
      className="my-20 max-w-3xl mx-auto px-4 text-center relative"
    >
      {/* Background overlay */}
      <div className="absolute inset-0 bg-gray-900 bg-opacity-30 rounded-lg -z-10"></div>

      <motion.h2
        className="text-4xl font-extrabold mb-4 text-softPurple relative"
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        Jack of Many Trades. Master of Most.
      </motion.h2>

      <motion.h3
        className="text-xl font-semibold text-gray-100 mb-6 relative"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        I’m the guy that gets it done.
      </motion.h3>

      <div className="flex flex-wrap justify-center gap-4 mb-10 relative">
        {roleBadges.map((role, index) => (
          <motion.div
            key={index}
            className="bg-gray-800 bg-opacity-70 text-gray-100 rounded-xl px-4 py-2 flex items-center gap-2 shadow-md"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 * index }}
          >
            {role.icon}
            <span className="text-sm font-medium">{role.label}</span>
          </motion.div>
        ))}
      </div>

      <div className="space-y-5 text-left relative">
        {paragraphLines.map((line, index) => (
          <motion.p
            key={index}
            className="text-gray-300 text-lg leading-relaxed"
            variants={textVariant}
            initial="hidden"
            whileInView="visible"
            custom={index}
            viewport={{ once: true }}
          >
            {line}
          </motion.p>
        ))}
      </div>
    </section>
  );
};


export default About;
